import { Card, Col, Row, Statistic, Typography } from 'antd'
import {
  GiftOutlined,
  TeamOutlined,
  TrophyOutlined,
  AppstoreOutlined,
} from '@ant-design/icons'

const { Title, Text } = Typography

export default function Dashboard() {
  return (
    <div>
      <Title level={2}>Dashboard</Title>
      <Text>Painel administrativo da Roleta Premiada.</Text>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} md={6}>
          <Card>
            <Statistic title="Eventos" value={1} prefix={<AppstoreOutlined />} />
          </Card>
        </Col>

        <Col xs={24} md={6}>
          <Card>
            <Statistic title="Brindes" value={0} prefix={<GiftOutlined />} />
          </Card>
        </Col>

        <Col xs={24} md={6}>
          <Card>
            <Statistic title="Participantes" value={0} prefix={<TeamOutlined />} />
          </Card>
        </Col>

        <Col xs={24} md={6}>
          <Card>
            <Statistic title="Giros" value={0} prefix={<TrophyOutlined />} />
          </Card>
        </Col>
      </Row>
    </div>
  )
}